module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiExtIt.c797a0f.eot";